import { TableAPIURL } from '../environment';
import { HTTP } from './services';

class ExternalUserService {
    
    async isExternalUser(email){
            try {
                const obj = {
                    "az_email": `${email}' AND active ='${true}' AND otp = '${""}`
                };
                const payload = {
                    table: "powerx.external_users",
                    action: "select",
                    data: [obj]
                };
                const response = await HTTP.POST(`${TableAPIURL}`,payload);
                if (response) {
                    return response;
                } else {
                    return { "success": false }
                }
            } catch (error) {
                console.log('externalUserQuery Post API Error', error);
                return { "success": false }
            }
        }
          
}

export const  externalUserServices = new ExternalUserService();
export default externalUserServices;

